import { primary } from '_lex/_foundations/phxColors';
import { FieldCategory } from '../FieldBank/_types';

export const getCategoryColor = (fieldCategory?: FieldCategory): string => {
  return fieldCategory?.color || primary[500];
};
